import { apiDelete, apiGet, apiPost, apiPut } from '../utils/apiClient';
import { isAdminUser } from '../constants';

export default class TemplateIntegration {
    listTemplates(gatewayUrl, tenantId, authToken) {
        const url = isAdminUser(tenantId)
            ? `${gatewayUrl}/bot-templates`
            : `${gatewayUrl}/bot-templates/createdby/${tenantId}`;

        return apiGet(url, { authToken });
    }

    createNewTemplate() {
        return apiGet(`${process.env.REACT_APP_JSON_URL}/newTemplate.json`)
            .then((d) => d.data);
    }

    getTemplate(botApiUrl, templateId, authToken) {
        return apiGet(`${botApiUrl}/bot-templates/${templateId}`, { authToken });
    }

    saveTemplate(botApiUrl, formData, authToken) {
        if (formData.id) {
            return apiPut(
                `${botApiUrl}/bot-templates/${formData.id}`,
                formData,
                { authToken }
            );
        }

        return apiPost(`${botApiUrl}/bot-templates`, formData, { authToken });
    }

    deleteTemplate(botApiUrl, templateId, authToken) {
        return apiDelete(`${botApiUrl}/bot-templates/${templateId}`, {
            authToken,
            parseJson: false,
        }).then(() => ({ success: true }));
    }
}
